<template>
    <input
    ref="el"
    :placeholder="placeholder"
    :required="required"
	v-model="inputValue"
    inputmode="tel"
    type="tel"
    >
</template>

<script>

import { watch, onMounted } from 'vue';
import { useIMask } from 'vue-imask';

export default {
    name : 'InputPhone',
    // components: {
    //     'imask-input': IMaskComponent
    // },
    props : {
        placeholder : {
            type : String,
            default : '+7 (___) ___ - __ - __',
        },
        value : {
            type : String,
            default : '',
        },
        modelValue : {
            type : String,
            default : '',
        },
        required : {
            type : [ Boolean, String, ],
            default : false,
        },
    },
    setup (props, { emit }) {
        const imask = useIMask({
            mask: '+{7} ({9}00) 000 - 00 - 00',
        });

        watch(imask.unmasked, unmaskedValue => {
            emit('update:modelValue', unmaskedValue);
        });

        watch(() => props.modelValue, () => {
            if(!props.modelValue) {
                return;
            }
            let unmaskedValue = props.modelValue.replace(/[^\d]/ig, '').substring(0, 11);
            imask.unmasked.value = unmaskedValue;
        });

        onMounted(() => {
            imask.unmasked.value = (props.modelValue || props.value).replace(/[^\d]/ig, '').substring(0, 11);

            imask.el.value.addEventListener('input', (e) => {
                const value = e.target.value.replace(/[^\d]/ig, '').substring(0, 11);
                imask.unmasked.value = value;
                e.target.value = imask.masked.value;
            });

            imask.el.value.addEventListener('v-kb-input', e => {
                imask.unmasked.value = e.detail.text.replace(/[^\d]/ig, '').substring(0, 11);
                imask.el.value.value = imask.masked.value;
            });
        });

        return {
            el : imask.el,
            maskedValue: imask.masked,
        };
    },
    computed: {
        inputValue: {
            get() {
                return this.maskedValue;
            },
            set(value) {
                this.maskedValue.value = value;
            }
        }
    }
}
</script>
